// extracted by mini-css-extract-plugin
module.exports = {"root":"_2tPee","actionPointsHolder":"_3xHKm","userInfoHolder":"_3hE43"};